export enum ChannelVisibility {
  PUBLIC = 1,
  LIMITED = 2,
  PRIVATE = 3,
}

export const ChannelVisibilityEnum: Record<ChannelVisibility, string> = {
  [ChannelVisibility.PUBLIC]: '公開',
  [ChannelVisibility.LIMITED]: '限定公開',
  [ChannelVisibility.PRIVATE]: '非公開',
};
